import React from 'react'
import { Clock, TrendingUp, Star } from 'lucide-react'

export interface MenuItem {
  name: string
  href: string
}

export interface ProductivityToolsCategory {
  category: string
  icon: React.ReactNode
  items: MenuItem[]
}

export const productivityTools: ProductivityToolsCategory[] = [
  {
    category: 'Save Time',
    icon: <Clock className="w-4 h-4" />,
    items: [
      { name: 'Collaboration Hub', href: '/services' },
      { name: 'Project Boards', href: '/services' },
      { name: 'Browser Extension', href: '/services' },
      { name: 'Client Onboarding', href: '/services' },
    ],
  },
  {
    category: 'Grow Revenue',
    icon: <TrendingUp className="w-4 h-4" />,
    items: [
      { name: 'Project Proposals', href: '/services' },
      { name: 'White Label Services', href: '/services' },
      { name: 'Client Health Tracking', href: '/services' },
      { name: 'Calendar Widgets', href: '/services' },
    ],
  },
  {
    category: 'Impress Clients',
    icon: <Star className="w-4 h-4" />,
    items: [
      { name: 'Client Portal', href: '/services' },
      { name: 'Client Feedback', href: '/services' },
      { name: 'Client Reporting', href: '/services' },
      { name: 'Google Ads Preview', href: '/services' },
    ],
  },
]

export const servicesMenu: MenuItem[] = [
  { name: 'Audit', href: '/audit' },
  { name: 'Build', href: '/services' },
  { name: 'Automate', href: '/ai' },
  { name: 'Looker Studio', href: '/looker' },
  { name: 'Custom Integrations', href: '/custom-integrations' },
]

// Helper to get productivity tools as an object (for backward compatibility)
export const getProductivityToolsObject = () => {
  return productivityTools.reduce((acc, category) => {
    acc[category.category] = category.items
    return acc
  }, {} as Record<string, MenuItem[]>)
}

// Helper to get category icon
export const getCategoryIcon = (category: string) => {
  const found = productivityTools.find((cat) => cat.category === category)
  return found?.icon || null
}
